import * as z from "zod";
import { null as zNull } from "zod";

export const deleteOrderTrackingOrderView = {
  name: "deleteOrderTrackingOrderView" as const,
  input: z.object({ name: z.string() }),
  output: zNull(),
};
